/**
 * kin-mimir-chat.js — open the Mimir chat from any link on the site.
 *
 * The Mimir app injects its loader store-wide
 * (https://bubble.trymimir.com/skinsecret.js?shop=t56mat-9r.myshopify.com); it is not part of the
 * theme. That loader registers window listeners for "mimir:open", "mimir:close",
 * "mimir:new-chat", "mimir:start-conversation", "mimir:show-proactive-message" and
 * "mimir:region-change", so a "chat with us" link only has to dispatch mimir:open.
 *
 * Contract: any <a> whose href ends with "#mimir-chat" opens the chat. An href — not a data
 * attribute, not onclick — because most places that offer the support email are rich-text
 * section settings where Shopify keeps only <a href>, and because a non-technical operator
 * can type "#mimir-chat" into the theme editor's link dialog.
 * The suffix match also covers an editor save that rewrites it to "/pages/x#mimir-chat".
 *
 * Delegation on document, so links inside a section re-rendered by the theme editor keep working.
 * See docs/mimir-chat-runbook.md.
 */
(() => {
  'use strict';

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('a[href$="#mimir-chat"]');
    if (!trigger) return;

    event.preventDefault();
    window.dispatchEvent(new Event('mimir:open'));
  });
})();
